import MobileDetect from "mobile-detect";

export default {
    data() {
        return {
            appUrl: "https://www.ltkgames.com/"
        };
    },
    mounted() {
        if (typeof window.navigator === "undefined") return false;

        const md = new MobileDetect(window.navigator.userAgent);

        if (md.os() === "iOS") {
            this.appUrl =
                "https://itunes.apple.com/app/hanghangmonster/id1439896302";
        } else if (md.os() === "AndroidOS") {
            this.appUrl =
                "https://play.google.com/store/apps/details?id=com.lovetoknow.hanghangmonster";
        } else {
            this.appUrl = "https://www.ltkgames.com/";
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/HomeCta/HomeCta.js